import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BfsiFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 3.00049C10.0001 1.89592 10.8955 1.00049 12.0001 1.00049C13.1047 1.00049 14.0001 1.89592 14.0001 3.00049C14.0001 4.10506 13.1047 5.00049 12.0001 5.00049C10.8955 5.00049 10.0001 4.10506 10.0001 3.00049ZM4.16806 3.44579C4.47441 2.98626 5.09528 2.86209 5.55481 3.16844L12.0001 7.4653L18.4454 3.16844C18.9049 2.86209 19.5258 2.98626 19.8322 3.44579C20.1385 3.90532 20.0143 4.52619 19.5548 4.83254L13.8029 8.66715L15.2028 9.60042C16.925 10.7486 16.9946 13.2546 15.3387 14.4966L13.6668 15.7505L19.6001 20.2005C20.0419 20.5319 20.1315 21.1587 19.8001 21.6005C19.4687 22.0423 18.8419 22.1319 18.4001 21.8005L12.0001 17.0005L5.60011 21.8005C5.15828 22.1319 4.53148 22.0423 4.20011 21.6005C3.86874 21.1587 3.95828 20.5319 4.40011 20.2005L10.3334 15.7505L8.66154 14.4966C7.00565 13.2546 7.07521 10.7486 8.79744 9.60042L10.1973 8.66715L4.44541 4.83254C3.98588 4.52619 3.8617 3.90532 4.16806 3.44579Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BfsiFilledIcon = assignWithoutSideEffects(_BfsiFilledIcon, {
  componentId: 'BfsiFilledIcon',
});

export default BfsiFilledIcon;
